import { useEffect, useState } from 'react';
import PostClientLogo from '../services/adapters/clientLogo';

export default function ClientLogo({ className }: { className?: string; }) {
  const [signedUrl, setSignedUrl] = useState('');

  useEffect(() => {
    const getLogo = async () => {
      const adapter = new PostClientLogo();
      const result = await adapter.adaptResponse();
      setSignedUrl(result);
    };
    getLogo();
  }, []);

  if (!signedUrl) return null;

  return (
    <img
      src={signedUrl}
      alt=""
      className={className ? `${className}` : 'max-h-full max-w-full object-contain'}
    />
  );
}
